import { render, staticRenderFns } from "./AlertVcDemo.vue?vue&type=template&id=5fa5a0ae&scoped=true&"
import script from "./AlertVcDemo.vue?vue&type=script&lang=js&"
export * from "./AlertVcDemo.vue?vue&type=script&lang=js&"
import style0 from "./AlertVcDemo.vue?vue&type=style&index=0&id=5fa5a0ae&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa5a0ae",
  null
  
)

export default component.exports